export const METRICS_PATH = 'debug-mtumet/transcript-with-metrics?';
export const TIMBER_PATH = 'debug-mtumet/timber?';
export const RTS_PATH = 'debug-mtumet/rtsdebug?';
export const RTS_TRANSLATION_INFO = 'translationInfo';

export const MISSING_PARAMETER_ERROR = 'Error: Missing input parameter(s)';
